import _ from "lodash";

export const parseAtts = profile => {
  const atts = ["gender", "identities"];
  if (
    _.has(profile.attributes, "gender") ||
    _.has(profile.attributes, "identities")
  ) {
    return _.forEach(atts, item => {
      const att = profile.attributes[item];
      if (att) {
        return _.set(
          profile,
          `attributes[${item}]`,
          JSON.parse(profile.attributes[item])
        );
      }
      return profile;
    });
  }
};

export const breadcrumbNameMap = {
  "/customers": "Clientes",
  "/orders": "Ordenes"
};



// WEBPACK FOOTER //
// ./src/Modules/utils.js